import { StarIcon } from '@heroicons/react/24/outline';
import { StarIcon as SolidStarIcon } from '@heroicons/react/24/solid';
import { useTheme } from 'next-themes';
import { ButtonHTMLAttributes, useEffect, useState } from 'react';

type LivescoreFavoriteTogglerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isFavorite: boolean;
};

const LivescoreFavoriteToggler = ({ isFavorite, id, ...props }: LivescoreFavoriteTogglerProps) => {
  const { theme, systemTheme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const [currentState, setCurrentState] = useState(isFavorite);

  useEffect(() => {
    if (isFavorite !== currentState) {
      setIsVisible(false);
      const timer = setTimeout(() => {
        setCurrentState(isFavorite);
        setIsVisible(true);
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(true);
    }
  }, [isFavorite, currentState]);

  const isDark = theme === 'system' ? systemTheme === 'dark' : theme === 'dark';

  return (
    <button {...props} className="!w-5 !h-5 relative">
      <span
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        {currentState ? (
          <SolidStarIcon
            width={20}
            // #31C46C primary-600
            color={'#31C46C'}
          />
        ) : (
          <StarIcon width={20} color={'transparent'} stroke={isDark ? 'white' : 'black'} strokeWidth={2} />
        )}
      </span>
      <p className="sr-only">Add match to favorites</p>
    </button>
  );
};

export default LivescoreFavoriteToggler;
